import type { TablesInsert } from "@/lib/supabase-types";

/**
 * Tables whose BEFORE INSERT trigger fills operator_id: `set_operator_id`, or
 * `set_operator_bank_submission_defaults` for operator_bank_submissions.
 */
type OperatorStampedTable =
  | "apartments"
  | "audit_logs"
  | "bookings"
  | "contract_templates"
  | "lessors"
  | "operator_bank_submissions"
  | "payments"
  | "properties"
  | "rooms"
  | "saas_subscriptions"
  | "tenant_documents";

/**
 * Insert payload without operator_id for a table the trigger stamps. The
 * generated Insert type still marks the column required, so this is the one
 * place that tells the compiler otherwise.
 */
export const operatorStamped = <T extends OperatorStampedTable>(
  row: Omit<TablesInsert<T>, "operator_id">
) => row as TablesInsert<T>;
